export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()
  const localePath = useLocalePath()
  const normalizePath = localePath(to.path, 'en')
  if (
    to.meta.auth &&
    !authStore.isAuthorized(to.meta.auth) &&
    !normalizePath.startsWith('/public')
  ) {
    console.error('unauthorized for navigation', to.meta.auth.roles)
    return abortNavigation()
  }
  return
})
